export default __webpack_public_path__ + "static/media/paused-sub-bg@3x.6dce97c3.png";